<template>
  <v-container
    id="previewUser"
    fluid
    tag="section"
    class="full-height"
  >
    <base-v-component
      heading="Преглед на потребител"
      goBackText="Обратно към потребители"
      goBackTo="/admin/users"
    />

    <v-row class="mt-10 d-print-none">
      <v-col cols="12" class="text-right">
        <v-btn
          class="success px-5"
          @click="saveData"
        >
          <v-icon
            left
            dark
          >
            mdi-check
          </v-icon>
          Запази
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="d-print-none">
      <v-col cols="12" class="mx-auto">
        <base-material-card 
          hover-reveal
          icon="mdi-account"
          color="primary"
          expandable
          expandableTitle="Потребител"
          :expanded.sync="expandUserDetails"
          :areAllCardsExpanded="areAllCardsExpanded"
          @collapseAllCards="collapseAllCards"
          @expandAllCards="expandAllCards"
        >
          <template v-slot:after-heading>
            <div class="font-weight-light card-title mt-2">
              Потребител
            </div>
          </template>

          <v-container class="py-7">
            <v-form
              ref="form"
              v-model="validForm"
              lazy-validation
            >
              <v-row>
                <v-col cols="12" md="4" sm="12">
                  <v-text-field
                    label="Име"
                    :rules="[rules.required, rules.min]"
                    v-model="data.firstName"
                  />
                </v-col>
                <v-col cols="12" md="4" sm="12">
                  <v-text-field
                    label="Презиме"
                    :rules="[rules.required, rules.min]"
                    v-model="data.middleName"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4" sm="12">
                  <v-text-field
                    label="Фамилия"
                    :rules="[rules.required, rules.min]"
                    v-model="data.lastName"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4" sm="12">
                  <v-text-field
                    label="E-mail (Потребителско име)"
                    :rules="[rules.required, rules.email]"
                    v-model="data.email"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4" sm="12">
                  <v-text-field
                    label="Телефон"
                    v-model="data.phone"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="2" sm="12">
                  <base-select
                      :items="properties.statuses"
                      item-text="label"
                      item-value="value"
                      v-model="data.status"
                      :rules="[rules.requiredSelect]"
                      label="Статус"
                  />
                </v-col>
                <v-col cols="12" md="2" sm="12">
                  <base-select
                      :items="properties.access"
                      item-text="label"
                      item-value="value"
                      v-model="data.access"
                      :rules="[rules.requiredSelect]"
                      label="Права"
                  />
                </v-col>
                <v-col cols="12" md="4" sm="12">
                  <v-text-field
                    v-model="data.password"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :rules="[rules.required, rules.minPassword]"
                    :type="showPassword ? 'text' : 'password'"
                    label="Парола"
                    hint="Паролата трябва да е поне 6 символа"
                    counter
                    @click:append="showPassword = !showPassword"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import { mapGetters } from "vuex";
import { getUser, saveUser } from '@/api/users'
import { ISODateString } from '@/utils';
export default {
  name: "previewUser",
  components: {
  },
  data(){
    return {
      properties: {
        statuses: [
          {label: "Активен", value: 1},
          {label: "Неактивен", value: 0}
        ],
        access: [
          {label: "Потребител", value: 1},
          {label: "Администратор", value: 0}
        ]
      },
      data: {},
      isNewDoc: true,
      expandUserDetails: true,
      showPassword: false,
      validForm: true,
      rules: {
        required: v => !!v || 'Полето е задължително.',
        requiredSelect: v => !isNaN(parseFloat(v)) && v >= 0 && v <= 999 || "Полето е задължително",
        min: v => (v && v.length >= 3) || 'Полето трябва да съдържа поне 3 символа',
        minPassword: v => (v && v.length >= 6) || 'Полето трябва да съдържа поне 6 символа',
        email: v => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail-a трябва да бъде валиден адрес.'
      },
    }
  },
  mounted(){
    if(this.$route.params.id != 'create'){
      this.data._id = this.$route.params.id;
      this.isNewDoc = false;
    }

    this.getData();
  },
  computed: {
    ...mapGetters([
      'lastRoute',
      'actionsAccess'
    ]),
    clientName() {
      return this.data.client.clientFullName;
    },
    areAllCardsExpanded(){
      return this.expandUserDetails;
    }
  },
  methods: {
    getData(){
      if(!this.isNewDoc)
        getUser(this.data._id).then(data => {
          this.data = data;
        })
    },
    saveData(){
      if(this.$refs.form.validate()){
        saveUser(this.data).then(response => {
          if(response && response._id && this.isNewDoc)
            this.$router.push({path: `/admin/users/${response._id}`})
        })
      }
    },
    expandAllCards(){
      this.expandUserDetails = true;
      this.$forceUpdate();
    },
    collapseAllCards(){
      this.expandUserDetails = false;
      this.$forceUpdate();
    },
    ISODateString: ISODateString
  }
}
</script>